import React, { useState, useRef, useCallback } from "react";
import ModalAlert from "../modal/modal_alert";
import axios from "../../sagas/axios";

const ReviewCreate = ({ event }) => {
  const [description, setDescription] = useState("");
  const [score, setScore] = useState(0)
  const modalAlertSuccessRef = useRef(null);
  const modalAlertErrorRef = useRef(null);
  const isProcessing = useRef(false);

  const onSubmit = useCallback(
    () => {
      if (isProcessing.current) return;
      isProcessing.current = true;

      const body = JSON.stringify({
        circle_id: event.circle.id,
        event_id: event.id,
        score: score,
        description: description,
      });
      axios
        .post("/api/circles_reviews", body)
        .then(() => {
          modalAlertSuccessRef.current.openModal();
        })
        .catch(() => {
          modalAlertErrorRef.current.openModal();
        });
    },
    [score, description, modalAlertSuccessRef, modalAlertErrorRef]
  );

  const toReportPage = () => {
    if (event.company_id) {
      location.href = "/community/" + event.company.id_to_param + "/circle/" + event.circle.id + "/events_for_redirect/" + event.id;

    } else {
      location.href = "/circle/" + event.circle.id + "/events_for_redirect/" + event.id;
    }
  };

  const Stars = () => {

    return (
      <div className="pt-2 mb-3">
        <a className="text-fz-30px" style={{ color: (score >= 1) ? '#ffd700' : '#ccc' }} onClick={() => setScore(1)}>★</a>
        <a className="text-fz-30px" style={{ color: (score >= 2) ? '#ffd700' : '#ccc' }} onClick={() => setScore(2)}>★</a>
        <a className="text-fz-30px" style={{ color: (score >= 3) ? '#ffd700' : '#ccc' }} onClick={() => setScore(3)}>★</a>
        <a className="text-fz-30px" style={{ color: (score >= 4) ? '#ffd700' : '#ccc' }} onClick={() => setScore(4)}>★</a>
        <a className="text-fz-30px" style={{ color: (score >= 5) ? '#ffd700' : '#ccc' }} onClick={() => setScore(5)}>★</a>
      </div>
    );
  };

  return (
    event ? (
      <div>
        <div className="container col-md-8 col-lg-6">
          <h1 className="text-fz-20px text-black-444 mb-2">
            主催者をレビュー
          </h1>
          <div className="d-flex flex-row pt-3">
            <div className="col-6">
              <div className="adjust-box adjust-box-3x2">
                <img
                  data-src={event.main_image_url_thumb}
                  alt="Event image"
                  className="rounded-top w-100 object-fit-cover adjust-box-inner lazyloaded"
                  onError={(e) => {
                    e.target.src = "/images/ja2/img_noimage.gif";
                  }}
                  src={event.main_image_url_thumb}
                />
              </div>
            </div>
            <div className="col-6 px-2">
              <p className="mb-2 mt-1 text-black-50 text-fz-12px text-fw-bold w-100">あなたの参加したイベント</p>
              <p className="mb-2 mt-2 text-black-444 text-fz-14px text-fw-bold w-100">{event.title}</p>
              <p className="mb-2 mt-2 text-black-444 text-fz-11px text-fw-bold w-100">{event.event_date_formatted}</p>
            </div>
          </div>
          <div className="row d-flex align-items-center pl-5">
            <div className="pl-3">
              <img
                data-src={event.circle.main_image_thumb}
                alt="Circle image"
                className="event-member-icon lazyloaded"
                onError={(e) => {
                  e.target.src = "/images/ja2/img_noimage.gif";
                }}
                src={event.circle.main_image_thumb}
              />
            </div>
            <p className="text-black-444 text-fz-14px mt-4 ml-3">{event.circle.name}</p>
          </div>
          <hr />
          <h2 className="text-fz-16px text-black-444 mb-2 pt-3">{event.circle.name}の感想・評価</h2>
          <Stars />
          <p className="text-fz-14px text-black-444 text-fw-bold pt-3 mb-3">メッセージ（任意）</p>
          <p className="mb-2 mt-1 text-gray text-fz-12px text-fw-bold w-100">同一サークルへのレビューのメッセージは、複数回送信すると最新の1件のみが表示対象となります。</p>
          <p className="mb-2 mt-1 text-gray text-fz-12px text-fw-bold w-100">イベントのレビューは、主催者の方に感謝を伝える場として活用ください。</p>
          <p className="mb-2 mt-1 text-gray text-fz-12px text-fw-bold w-100">また、参加者の皆さんのレビューは、参加を検討する他の参加者に取って有益な情報になります</p>
        </div>
        <div className="container col-md-8 col-lg-6">
          <textarea
            value={description}
            id="description"
            cols="5"
            rows="6"
            className="p-3 w-100 form-control bg-gray"
            placeholder="初参加だったのですが、みなさんが親切に話しかけてくれてとても楽しめました。"
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className="container col-md-8 col-lg-6">
          <div className="d-flex justify-content-around pt-3">
            <button
              className="a-button a-button__top a-button--orange mb-3 w-100"
              onClick={() => onSubmit()}
              disabled={score === 0}
            >
              送信する
            </button>
          </div>
        </div>
        <ModalAlert
          ref={modalAlertSuccessRef}
          title="レビュー投稿完了"
          content="レビューを投稿しました。"
          approveFunc={toReportPage}
        />
        <ModalAlert
          ref={modalAlertErrorRef}
          title="レビュー投稿失敗"
          content="レビュー投稿に失敗しました。時間をおいてもう一度お試しください。"
        />
      </div>
    ) : (
      <div className="container col-md-8 col-lg-6">
        <h1 className="text-fz-20px text-black-444 text-center pt-5 mb-5">
          レビューできるイベントがありません
        </h1>
        <div className="d-flex justify-content-around">
          <button
            className="a-button a-button__top a-button--orange mb-3 w-100"
            onClick={toReportPage}
          >
            戻る
          </button>
        </div>
      </div>
    )
  );
};

export default ReviewCreate;
